import { useState } from "react";
import Companies from "./Companies";
import Persons from "./Persons";
import ClientValue from "./ClientValue";
import MergeContacts from "../components/MergeContacts";
import DuplicatesScan from "../components/DuplicatesScan";
import EmailHealth from "../components/EmailHealth";
import usePersistedState from "../hooks/usePersistedState";

const TABS = [
  { id: "aziende", label: "Aziende" },
  { id: "persone", label: "Persone" },
  { id: "valore", label: "Valore clienti" },
];

export default function Contatti() {
  const [tab, setTab] = usePersistedState("contatti.tab", "aziende");
  const [mergeOpen, setMergeOpen] = useState(false);
  const [scanOpen, setScanOpen] = useState(false);
  const [healthOpen, setHealthOpen] = useState(false);
  return (
    <div>
      <h1 className="page-title">Contatti</h1>
      <div className="toolbar" style={{ gap: 8, marginBottom: 14 }}>
        {TABS.map((t) => (
          <button key={t.id} className={"btn" + (tab === t.id ? " primary" : "")} onClick={() => setTab(t.id)} data-testid={`contatti-tab-${t.id}`}>{t.label}</button>
        ))}
        <div className="spacer" />
        <button className="btn" onClick={() => setHealthOpen(true)} data-testid="contatti-health-btn">🩺 Controllo email</button>
        <button className="btn" onClick={() => setScanOpen(true)} data-testid="contatti-scan-btn">🧬 Trova doppioni</button>
        <button className="btn" onClick={() => setMergeOpen(true)} data-testid="contatti-merge-btn">🔀 Unifica doppioni</button>
      </div>
      {tab === "aziende" && <Companies embedded />}
      {tab === "persone" && <Persons embedded />}
      {tab === "valore" && <ClientValue embedded />}
      {mergeOpen && <MergeContacts onClose={() => setMergeOpen(false)} />}
      {scanOpen && <DuplicatesScan onClose={() => setScanOpen(false)} />}
      {healthOpen && <EmailHealth onClose={() => setHealthOpen(false)} />}
    </div>
  );
}
